export default __webpack_public_path__ + "static/media/deseoPostular.c9412c14.svg";